import { COMPONENT_TYPE } from 'Constants/filters';
import { arrayToObject } from './array';

const minAbundance = 5;

const buildFiltersTreeForVariousFiltersFunctions = {
    [COMPONENT_TYPE.NESTED_SELECT]: (filterInfo, allFiltersInfo, abundanceFilterObj) => {
        const { customConfiguration } = filterInfo.render;
        const { nestedFilterAttr, attribute } = filterInfo;
        const nestedFilterInfo = allFiltersInfo[nestedFilterAttr];
        const { customConfiguration: nestedFiltersConfiguration } = nestedFilterInfo && nestedFilterInfo.render;

        if (customConfiguration) {
            const { values, valuesInfo } = customConfiguration;
            const { valuesInfo: nestedValuesInfo = {}} = nestedFiltersConfiguration || {};

            const children = values
                .reduce((acc, value) => {
                    if (value != -1) {
                        const valueInfo = valuesInfo[value];
                        const { nestedValues = [] } = valueInfo;
                        const filter = {
                            id: value,
                            label: valueInfo.name,
                            filters: {
                                [attribute]: value
                            },
                            children: {
                                label: nestedFilterInfo.name,
                                id: nestedFilterAttr,
                                values: nestedValues
                                    .reduce((acc, nestedFilterValue) => {
                                        if (nestedValuesInfo[nestedFilterValue]) {
                                            const nestedFilterValueInfo = nestedValuesInfo[nestedFilterValue];

                                            if (abundanceFilterObj) {
                                                const nestedFilterAbundance = abundanceFilterObj[nestedFilterAttr] || {};
                                                const nestedFilterAbundanceObj = arrayToObject(nestedFilterAbundance.values, 'id') || {};

                                                if (nestedFilterAbundanceObj[nestedFilterValue] && nestedFilterAbundanceObj[nestedFilterValue].count > minAbundance) {
                                                    acc.push({
                                                        id: nestedFilterValue,
                                                        label: nestedFilterValueInfo.name,
                                                        filters: {
                                                            [nestedFilterAttr]: nestedFilterValue
                                                        }
                                                    });
                                                }
                                            }
                                            else {
                                                acc.push({
                                                    id: nestedFilterValue,
                                                    label: nestedFilterValueInfo.name,
                                                    filters: {
                                                        [nestedFilterAttr]: nestedFilterValue
                                                    }
                                                });
                                            }
                                        }
                                        return acc;
                                    }, [])
                            }

                        };

                        if (abundanceFilterObj) {
                            const filterAbundance = abundanceFilterObj[attribute] || {};
                            const filterAbundanceObj = arrayToObject(filterAbundance.values, 'id') || {};

                            if (filterAbundanceObj[value] && filterAbundanceObj[value].count > minAbundance) {
                                acc.push(filter);
                            }
                        }
                        else {
                            acc.push(filter);
                        }
                    }
                    return acc;
                }, []);

            return {
                id: attribute,
                heading: filterInfo.sectionName,
                values: children,
                nestedFilters: [nestedFilterAttr]
            };
        }
        return null;
    },
    [COMPONENT_TYPE.SELECT]: filterInfo => {
        const { customConfiguration } = filterInfo.render;
        const { attribute } = filterInfo;

        if (customConfiguration) {
            const { values } = customConfiguration;

            const children = values
                .filter(valueInfo => valueInfo.value != -1)
                .reduce((acc, valueInfo) => {
                    if (valueInfo.value != -1) {
                        acc.push({
                            id: valueInfo.value,
                            label: valueInfo.name,
                            filters: {
                                [attribute]: valueInfo.value
                            }
                        });
                    }
                    return acc;
                }, []);

            return {
                id: attribute,
                heading: filterInfo.sectionName,
                values: children
            };
        }

        return null;
    },
    RANGE: filterInfo => {
        const { popularConfiguration, customConfiguration } = filterInfo.render;
        const { attribute } = filterInfo;

        if (popularConfiguration) {
            const { options } = popularConfiguration;

            const children = options.map(option => {
                const { range, name } = option;
                const { range: { maxValue = -1 } = {}} = customConfiguration || {};
                const obj = {
                    min: range?.minValue
                };

                if (range?.maxValue !== maxValue) {
                    obj.max = range?.maxValue;
                }

                return {
                    id: name,
                    label: name,
                    filters: {
                        [attribute]: obj
                    }
                };
            });

            return {
                id: attribute,
                heading: filterInfo.sectionName,
                values: children
            };
        }

        return null;
    }
};

export const buildFiltersTreeForVariousFilters = {
    [COMPONENT_TYPE.NESTED_SELECT]: buildFiltersTreeForVariousFiltersFunctions[COMPONENT_TYPE.NESTED_SELECT],
    [COMPONENT_TYPE.SELECT]: buildFiltersTreeForVariousFiltersFunctions[COMPONENT_TYPE.SELECT],
    [COMPONENT_TYPE.RANGE_SLIDER]: buildFiltersTreeForVariousFiltersFunctions.RANGE,
    [COMPONENT_TYPE.RANGE_INPUT]: buildFiltersTreeForVariousFiltersFunctions.RANGE
};

export const getPopularFilters = {
    [COMPONENT_TYPE.NESTED_SELECT]: filterInfo => {
        const { popularConfiguration } = filterInfo.render;
        const { nestedFilterAttr, attribute } = filterInfo;

        if (popularConfiguration) {
            const { options } = popularConfiguration;

            const children = options
                .map(option => {
                    const { name, value } = option;

                    return {
                        id: value,
                        label: name,
                        filters: {
                            [attribute]: value
                        }
                    };
                });

            return {
                id: attribute,
                heading: popularConfiguration.label,
                values: children,
                nestedFilters: [nestedFilterAttr]
            };
        }
        return null;
    },
    [COMPONENT_TYPE.SELECT]: buildFiltersTreeForVariousFiltersFunctions[COMPONENT_TYPE.SELECT],
    [COMPONENT_TYPE.RANGE_INPUT]: buildFiltersTreeForVariousFiltersFunctions.RANGE,
    [COMPONENT_TYPE.RANGE_SLIDER]: buildFiltersTreeForVariousFiltersFunctions.RANGE
};
